<template>
  <div class="col-2 side-nav-bar px-1 position-fixed">
    <div
      id="v-pills-tab"
      class="nav col-12 flex-column nav-pills pr-0"
      role="tablist"
      aria-orientation="vertical"
    >
      <router-link
        v-for="(route, index) in activeRoutes"
        :key="index"
        :to="{ name: route.routeTo }"
        active-class="active"
        class="nav-link"
      >
        <span>{{ route.title }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import permissionKeys from "@/constants/_permissions";
import modules from "@/constants/_modules";
import role from "@/mixins/role";

export default {
  name: "SideNav",
  mixins: [role],
  data() {
    return {
      navs: [
        {
          title: "Home",
          routeTo: "home.index",
          module: "home",
          enable: permissionKeys.VIEW
        },
        {
          title: "Alerts",
          routeTo: "alert.index",
          module: modules.ALERT,
          enable: permissionKeys.VIEW
        },
        {
          title: "Progress View",
          routeTo: "patientProgress.index",
          module: modules.PATIENTPROGRESS,
          enable: permissionKeys.VIEW
        },
        {
          title: "Patient List",
          routeTo: "patientList.index",
          module: modules.PATIENTLIST,
          enable: permissionKeys.VIEW
        },
        {
          title: "Patient List",
          routeTo: "followUpPatientList.index",
          module: modules.FOLLOWUP,
          enable: permissionKeys.CREATE
        },
        {
          title: "Follow Ups",
          routeTo: "followUp.index",
          module: modules.FOLLOWUP,
          enable: permissionKeys.CREATE
        },
        {
          title: "Care Plan",
          routeTo: "careplan.index",
          module: modules.CAREPLAN,
          enable: permissionKeys.VIEW
        },
        {
          title: "Reminders",
          routeTo: "patientProgress.index",
          module: modules.REMINDER,
          enable: permissionKeys.VIEW
        },
        {
          title: "Patients",
          routeTo: "patient.index",
          module: modules.PATIENT,
          enable: permissionKeys.VIEW
        },
        {
          title: "All Users",
          routeTo: "user.index",
          module: modules.USER,
          enable: permissionKeys.VIEW
        },
        // Priyakant - Work in progress
        {
          title: "Groups",
          routeTo: "group.index",
          module: modules.GROUP,
          enable: permissionKeys.VIEW
        },
        {
          title: "Create User",
          routeTo: "user.create",
          module: modules.USER,
          enable: permissionKeys.CREATE
        },
     
        {
          title: "Profile",
          routeTo: "profile.index",
          module: modules.PROFILE,
          enable: permissionKeys.VIEW
        },
        {
          title: "Care Giver(s)",
          routeTo: "delegates.index",
          module: modules.DELEGATE,
          enable: permissionKeys.VIEW
        },
        {
          title: "Send Message",
          routeTo: "message.index",
          module: modules.PATIENTMESSAGE,
          enable: permissionKeys.VIEW
        },
        {
          title: 'Reports',
          routeTo: 'reports.index',
          module: modules.REPORTS,
          enable: permissionKeys.VIEW
        }
      ]
    };
  },
  computed: {
    activeRoutes() {
      return this.navs.filter(nav =>
        this.modulePermissions[nav.module.toLowerCase()]
          ? this.modulePermissions[nav.module.toLowerCase()][
              nav.enable.toLowerCase()
            ]
          : false
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
